import React from 'react'
import Banner from './Banner'
// import Slider3 from './Slider3'
import Slider4 from './Grand Global Brand/Slider4'
// import Category from './Shop by category/Category'
import Footer from './Footer'
import RisingStar from './Rising Star/RisingStar'
import Offers from './Special Offers/Offers'
import ShopFavorites from './Productsec'
// import Categories from './Categories/Categories'
import HomeSection1 from './HomePages/HomeSection1'
import Categories from './Categories/Categories2'
// import HomeSection3 from './HomePages/HomeSection3'
// import TrendingCategory from './HomePages/TrendingCategory'
// import BestSeller from './HomePages/BestSellar'
// import NewArrivals from './HomePages/NewArrivals'
// import Curated from './HomePages/Curated'
import PicksSection from './HomePages/PicksSection'

import Arrival_new from './HomePages/Arrival_new'
import Sellar_best from './HomePages/Sellar_best'
import Ghrshya_drop from './HomePages/Ghrshya_drop'
import FabricsParatha from './HomePages/FabricsParatha'
import CottonParatha from './HomePages/CottonParatha'
import LaunchParatha from './HomePages/LaunchParatha'
import BanScrollParatha from './HomePages/BanScrollParatha'
// import { ProductNew } from './HomePages/ProductNew'






const Home = () => {
  return (
    <div>
      <Banner/>
      <LaunchParatha/>
       {/* <Categories/> */}
      {/* <Curated/> */}
     
      <HomeSection1/>
      <FabricsParatha/>
      <CottonParatha/>
      <PicksSection/> 
       {/* <Ghrshya_drop/> */}
       <BanScrollParatha/>
       <Sellar_best/>
      {/* <Arrival_new/> */}
      
      {/* <RisingStar/> */}
      
      {/* <ShopFavorites/> */}
      {/* <Offers/> */}
     
      {/* <Slider4/> */}
          <Footer/>
    </div>
  )
}

export default Home
